<template>
  <div class="container">
    <mt-header class="header" :title="title">
      <header-item slot="left" v-bind:isBack=true v-on:onclick="goBack">
      </header-item>
    </mt-header>
    <iframe sandbox="allow-forms allow-scripts allow-same-origin allow-popups allow-modals" id="iframe" class="content-wrapper" :style="getFrameStyle" :src="getUrl"></iframe>
  </div>
</template>

<script>
import { HeaderItem, Webview } from '../../components/common'
import { Header, MessageBox } from 'mint-ui'
import { mapState, mapMutations, mapActions } from 'vuex'
import { ENUM } from '../../const/enum';
export default {
  data() {
    return {
      frameHeight: 0,
      title: ''
    }
  },
  created(){

  },
  computed: {
    ...mapState({
			shopId: state => state.auth.shop.id,
			config: state => state.config.config,
		}),
    getUrl: function () {
      let url = this.$route.query.url;
      return url
    },
    getFrameStyle: function () {
      return {
        height: this.frameHeight + 'px',
      }
    }
  },
  methods: {
    goBack() {
      this.$router.go(-1)
    },
    loadConfig(imgUrl, name, desc, link) {
      this.fetchConfig().then(response => {
      	let wechat = response.config['wechat.web']
      	let openid = this.$cookie.get('o')
      	if (wechat) {  // 微信已授权
      		this.setWechatConfig(wechat, name, imgUrl, desc, link) 
      	} 
      }, error => {        
      })
		},
    setWechatConfig(config, name, imgUrl, desc, link) {
    	this.wxApi.wxRegister(config, name, imgUrl, desc, link)
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.frameHeight = document.body.scrollHeight - 44
      let iframe = document.getElementById("iframe")
      let title = this.$route.query.title
      // alert(iframe.src)
      if (title && title.length) {
        this.title = title
      } else {
        this.title = iframe.contentWindow.document.title
      }
      let imgUrl = require('../../assets/image/change-icon/app-icon.png')
      // 微信分享给朋友
      let scope = 'snsapi_userinfo'; // 允许获取用户信息
      let cid = this.$cookie.get("cid")
      let shopId = this.shopId || ''
      let ref = encodeURIComponent(window.location.href+"&cid="+cid+"&shopId="+shopId);
      let link = env.API_HOST + '/v2/ecapi.auth.web?vendor=' + ENUM.SOCIAL_VENDOR.WEIXIN + '&scope=' + scope + '&referer=' + ref +'&cid=' + cid;
      let desc = this.title
      if (!this.config) {
        this.loadConfig(imgUrl, this.title, desc, link)
      } else {
        let wechat = this.config['wechat.web']
        this.setWechatConfig(wechat, this.title, imgUrl, desc, link) 
      }
    })
  },
}

</script>

<style lang="scss" scoped>
  .container {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: stretch;
    background-color: $mainbgColor;
  }
  .header {
    @include header;
    border-bottom: 1px solid $lineColor;
    background-color: #eb8419;
  }
  .content-wrapper {
    border: none;
    width: 100%;
    height: 100%;
  }
</style>





// WEBPACK FOOTER //
// src/page/auth/WebPage.vue